import { Check, X } from 'lucide-react';

export interface ProsAndConsProps {
  prosList?: string[];
  consList?: string[];
}

export function ProsAndCons({ prosList, consList }: ProsAndConsProps) {
  const hasPros = Boolean(prosList?.length);
  const hasCons = Boolean(consList?.length);

  if (!hasPros && !hasCons) return null;

  return (
    <div className="flex flex-col gap-7 md:flex-row">
      {hasPros ? (
        <div className="flex-1">
          <h2 className="typography-text-large-bold mb-2 block border-b-2 border-primary pb-1">
            Pros
          </h2>
          <ul className="list-none p-0">
            {prosList?.map((item, index) => (
              <li className="flex items-start gap-2 py-1" key={`pros-${index}`}>
                <Check aria-hidden="true" className="shrink-0 text-[#2e7d32]" size={22} />
                {item}
              </li>
            ))}
          </ul>
        </div>
      ) : null}
      {hasCons ? (
        <div className="flex-1">
          <h2 className="typography-text-large-bold mb-2 block border-b-2 border-destructive pb-1">
            Cons
          </h2>
          <ul className="list-none p-0">
            {consList?.map((item, index) => (
              <li className="flex items-start gap-2 py-1" key={`cons-${index}`}>
                <X aria-hidden="true" className="shrink-0 text-[#d32f2f]" size={22} />
                {item}
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </div>
  );
}
